export const toSpaces = (str: string) => str.replace(/[_-]/g, " ");

export const toTitleCase = (str: string) =>
	toSpaces(str).replace(/\b\w/g, (char) => char.toUpperCase());

/**
 * Derive an editable external id from a display name (kebab-case).
 * Empty / non-alphanumeric input yields `""` (safe for controlled inputs).
 */
export const toKebabCaseId = (value: string): string =>
	value
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.trim()
		.toLowerCase()
		.replace(/[''`]/g, "")
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/^-+|-+$/g, "")
		.replace(/-+/g, "-");
